import * as React from 'react';

export type Theme = 'light' | 'dark' | 'system';

export interface ThemeContextValue {
  theme: Theme;
  setTheme: (theme: Theme) => void;
}

// Külön fájlban a `ThemeProvider`-től (react-refresh/only-export-components): a Context + a hook
// nem komponens, egy fájlban a providerrel megzavarná a Fast Refresh-t.
export const ThemeContext = React.createContext<ThemeContextValue | undefined>(undefined);

export function useTheme(): ThemeContextValue {
  const ctx = React.useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within a ThemeProvider');
  return ctx;
}
